import React from "react";
import styled from "styled-components";
import { Info } from "@material-ui/icons";

const CancelBox = styled.div`
  color: #000;
  background: #f1e1e2;
  font-size: 15px;
  padding: 10px;
  width: 220px;
  font-weight: 400;
  float: right;
  border: 1px solid #e26d69;
  margin-bottom: 10px;
  svg {
    color: #e26d69;
    padding-right: 10px;
    vertical-align: top;
  }
  p {
    color: #333;
    font-size: 13.5px;
    margin: 0px;
    line-height: 19px;
    display: inline-block;
    width: 80%;
    span {
      color: #e26d69;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export default function GCancelBox(props) {
  return (
    <CancelBox>
      {props.handleClick ? (
        <React.Fragment>
          <Info />
          <p>
            Having issue with this order?{" "}
            <span onClick={props.handleClick}>Click here</span> to cancel it.
          </p>
        </React.Fragment>
      ) : props.data ? (
        <React.Fragment>
          <p
            style={{
              margin: "3px 0",
              fontSize: "14px",
              color: "#e26d69",
            }}
          >
            Order Cancelled -{" "}
          </p>
          <p style={{ margin: "0", fontSize: "14px", color: "#e26d69" }}>
            {props.data.reason}
          </p>
        </React.Fragment>
      ) : (
        ""
      )}
    </CancelBox>
  );
}
